import { useLocation } from "react-router";

export default function useSearchParams(key) {
  const search = useLocation().search;
  const value = new URLSearchParams(search).get(key);
  return value?.toString();
}
